import api from "./index";

export const getSlug = async (slug) => await api.get(`/totem/${slug}`);

export const verifyCodeAccessAndPosition = async ({ slug, code, position }) =>
  await api.post(`/auth/totem`, {
    slug: slug,
    secret: code,
    position: position,
  });

export const getTotem = async (token, slug) =>
  await api.get(`/totem/${slug}/details`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

export const getCredentialsByDocument = async (token, document) =>
  await api.post(
    `/accreditation/by-document`,
    { document: document },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

export const logoutShutdownTotem = async (token, slug, code) =>
  await api.post(
    `/totem/${slug}/shutdown`,
    { accessCode: String(code) },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

export const reprintCredentialTotem = async (
  token,
  { extension = "png", password, action, reason }
) =>
  await api.patch(
    `/credential-reports/totem/reprint`,
    {
      password,
      action,
      reason,
    },
    {
      params: {
        extension,
      },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

/**
 * Heartbeat para manter sessão do totem viva
 * Deve ser chamado a cada 5 minutos para atualizar last_used_at no backend
 * @param {string} token - JWT token do totem
 * @returns {Promise<Response>} Response com status 204 (No Content) se sucesso
 */
export const totemHeartbeat = async (token) =>
  await api.put(`/auth/totem/session/ping`, null, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

/**
 * Login com override - assumir posição em uso
 * Usado quando há uma sessão ativa e o usuário confirma assumir a posição
 * @param {string} slug - Identificador do totem
 * @param {string} code - Código de acesso
 * @param {number} position - Posição desejada
 * @param {string} overrideReason - Motivo para assumir posição (mín 10 caracteres)
 * @returns {Promise<Response>} Response com token se sucesso
 */
export const totemOverrideLogin = async (slug, code, position, overrideReason) =>
  await api.post(`/auth/totem`, {
    slug: slug,
    secret: code,
    position: parseInt(position, 10),
    isOverride: true,
    overrideReason: overrideReason,
  });
